function setViewportHeight() {
  const vh = window.visualViewport?.height || window.innerHeight;

  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

if (window.visualViewport) {
  setViewportHeight();
  window.visualViewport.addEventListener('resize', setViewportHeight);
}